import { AppDefinition } from '../../types/apps';

export const DiagramAppDefinition: AppDefinition = {
  appId: 'diagram',
  name: 'Diagram',
  version: '0.1.0',
  description:
    'A live HTML/CSS/JS editor with real-time collaborative editing and a sandboxed live preview. Write HTML, style it with CSS, add interactivity with JavaScript — the preview updates as you type.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'AppWindow',
    phosphorWeight: 'duotone',
    color: '#6366f1',
    metadata: { source: 'app', appId: 'diagram', isAppIcon: true },
  },
  entityIcons: {
    Diagram: {
      type: 'phosphor',
      phosphorIcon: 'AppWindow',
      phosphorWeight: 'duotone',
      color: '#6366f1',
    },
  },
  entityTypes: ['Diagram'],
  searchableSkeletonFields: {
    // The Y.Doc is the source of truth; only the thin mirror is indexed — never the raw HTML.
    Diagram: ['description', 'tags', 'title'],
  },
  component: 'DiagramApp',
  requiresProps: false,
  requiresEntity: true,
  agenticToolIds: [
    'diagram_create',
    'diagram_write',
    'entity_read_content',
  ],
  actions: {},
  // No standalone app icon (Dock/Store/CreateMenu Apps section) — "New
  // Diagram" stays available as a quick-create entry everywhere.
  hidden: true,
};
